import { useEffect } from 'react';
import SupportHero from './components/SupportHero';
import SupportWhyNeeded from './components/SupportWhyNeeded';
import SupportWorkStages from './components/SupportWorkStages';
import SupportPackage from './components/SupportPackage';
import SupportBenefits from './components/SupportBenefits';
import SupportLeadForm from './components/SupportLeadForm';
import Footer from '../landing-page/components/Footer';
import { useSEO } from '../../utils/seo';

export default function LandingPageSupport() {
  useSEO({
    title: 'Ежемесячное сопровождение сайта Москва | SEO-поддержка и контент-маркетинг',
    description: 'Комплексная SEO-поддержка сайта от 3000 руб/месяц. Технический мониторинг, SEO-оптимизация, статьи и актуализация контента. Ваш сайт растёт, пока вы развиваете бизнес.',
    keywords: 'сопровождение сайта, поддержка сайта, SEO сопровождение, контент-маркетинг, техническая поддержка',
    canonical: '/landing-page-support',
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SupportHero />
      <SupportWhyNeeded />
      <SupportWorkStages />
      <SupportPackage />
      <SupportBenefits />
      <SupportLeadForm />
      <Footer />
    </div>
  );
}
